var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkuFileUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2495 0H5.74991C4.35882 0.00415459 3.0259 0.558603 2.04225 1.54225C1.0586 2.5259 0.504155 3.85882 0.5 5.24991V20.7546L7.28988 13.9648C8.29034 13.0125 9.61864 12.4815 10.9998 12.4815C12.381 12.4815 13.7093 13.0125 14.7098 13.9648L19.7339 19.0169L21.2879 17.4629C22.2742 16.4822 23.6086 15.9316 24.9996 15.9316C26.3905 15.9316 27.725 16.4822 28.7113 17.4629L35.4994 24.2546V5.24991C35.4952 3.85882 34.9408 2.5259 33.9571 1.54225C32.9735 0.558603 31.6406 0.00415459 30.2495 0Z",
    fill: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7098 13.9638C13.7093 13.0115 12.381 12.4805 10.9998 12.4805C9.61864 12.4805 8.29034 13.0115 7.28988 13.9638L0.5 20.7537V29.7485C0.504155 31.1396 1.0586 32.4725 2.04225 33.4562C3.0259 34.4398 4.35882 34.9943 5.74991 34.9984H30.2495C31.6757 34.9984 33.0407 34.4157 34.0294 33.3884L14.7098 13.9638Z",
    fill: "#FFD822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5003 24.2531L28.7122 17.4649C27.7259 16.4841 26.3915 15.9336 25.0005 15.9336C23.6096 15.9336 22.2751 16.4841 21.2888 17.4649L19.7349 19.0189L34.0234 33.3844C34.9718 32.4132 35.5021 31.1094 35.5003 29.7515V24.2531Z",
    fill: "#FFF0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuFileUploadIcon);
export default __webpack_public_path__ + "static/media/skuFileUploadIcon.5d86e3026f2de430fb77dda4955294dc.svg";
export { ForwardRef as ReactComponent };